/**
 * The kid chore/mission CONTROL glyphs — one source for the round-control icons so the day board
 * (`OccCard`) and the Missions shelf (`MissionTile`) render the SAME camera / retry / check, keeping a
 * photo-proof chore and a photo-proof mission visually identical. Paired with the `.check` / `.check.cam`
 * / `.check.redo` circles in `today.css`.
 */

/** The tick a complete / done control shows (`faint` for the not-yet-done placeholder). */
export const CheckGlyph = ({ faint = false }: { faint?: boolean }): React.ReactElement => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M5 13l4 4L19 7"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity={faint ? 0.55 : 1}
    />
  </svg>
);

/** A camera — a photo-proof chore/mission's control (tap opens the detail to add the photo). */
export const CameraGlyph = (): React.ReactElement => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M4 8.5h3L8.4 6h7.2L17 8.5h3a1 1 0 011 1V18a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5a1 1 0 011-1z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="13" r="3.1" stroke="currentColor" strokeWidth="2" />
  </svg>
);

/** A circular arrow — a rejected chore/mission's "try again" control. */
export const RedoGlyph = (): React.ReactElement => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M19 11a7 7 0 10-1.6 5"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 5v4h-4"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
